/**
 * @file enums.ts
 */
export enum MailOrderStatus {
  IN_PROGRESS = 'In-Progress',
  SHIPPED = 'Shipped',
  DELIVERED = 'Delivered',
  WAITING_FOR_PAYMENT = 'Waiting for Payment',
  READY_FOR_PICK_UP = 'Ready for Pickup',
  PICKED_UP = 'Picked-Up',
  CONTACTING_PRESCRIBER = 'Contacting Prescriber',
  PAYMENT = 'Payment',
  HOLD_TILL_REQUESTED = 'On Hold Until Requested',
  CANCELLED = 'Cancelled',
}

export enum ACTIVE_PRESCRIPTION_STATUS {
  TOO_SOON = 'Too Soon',
  IN_PROGRESS = 'In progress',
  REFILL = 'Refill',
  REQUEST_RENEW_PRESCRIPTION = 'Renew',
}

export enum INACTIVE_PRESCRIPTION_STATUS {
  TRANSFERRED = 'Transferred',
  INACTIVE = 'Inactive',
  NO_MORE_REFILLS = 'No more refills'
}

export enum HISTORICAL_ENTITY {
  ORDERS = 'ORDERS',
  CLAIMS = 'CLAIMS',
  PRESCRIPTIONS = 'PRESCRIPTIONS'
}

export enum HISTORICAL_DATA {
  MEMBER_PORTAL = 'MemberPortal'
}

export enum NAVIGATE_TO {
  RECENT = 'recent',
  HISTORY ='history'
}

export enum PAGE_NAME {
  HOME_PRESCRIPTION = 'Home - Prescription',
  HOME_BANNER = "Home - Banner",
  HOME_UPDATE_DIALOG = 'Home - Update Dialog',
  ORDERS = 'Orders',
  NOTIFICATIONS = 'Notifications',
  SHIPPING_ADDRESS= 'Shipping Addresses',
  PAYMENT_METHODS = 'Payment Methods',
  PRESCRIPTIONS = 'Prescriptions',
  FAMILY_PROFILES= 'Family profiles',
  FORMS = 'Forms'
}